


import { setGetMailingStatisticsScrollerUsersDepositsByCurrencyAction } from '../action';
import { getMailingStatisticsScrollerUsersDepositsByCurrency } from '../api/getMailingStatisticsScrollerUsersDepositsByCurrency';

export const setGetMailingStatisticsScrollerUsersDepositsByCurrency = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getMailingStatisticsScrollerUsersDepositsByCurrency(params);

            dispatch(setGetMailingStatisticsScrollerUsersDepositsByCurrencyAction(data))
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}